export const NOW_SHIPPING_MODAL_ID = 'now-shipping-modal'
export const NOW_SHIPPING_CART_MODAL_ID = 'now-shipping-cart-modal'
export const NOW_SHIPPING_MODAL_CONTAINER_ID = 'now-shipping-modal-container'
export const NOW_SHIPPING_MODAL_CART_CONTAINER_ID =
  'now-shipping-modal-cart-container'
